/** Wrap evaluation dashboard KPI strips so alert label ink meets AA on tinted cards. */
export const EVAL_DASHBOARD_KPI_A11Y_CLASS = "eval-dashboard-kpi-a11y"

/** KPI strip sits flush under PageHeader — parent supplies horizontal inset. */
export const EVAL_DASHBOARD_KPI_STRIP_CLASS = "px-0 py-0 lg:px-0"

/** Workflow section H2 — sans only; serif reserved for page H1. */
export const EVAL_DASHBOARD_SECTION_H2_CLASS =
  "text-lg font-semibold leading-snug text-foreground"

/** Term names on evaluation term cards — sans, same rhythm as ChartCard titles. */
export const EVAL_TERM_CARD_TITLE_CLASS =
  "text-sm font-semibold leading-tight text-foreground"
